import { graphql } from "../generated/gql";

export const GetAnalyticsCallDetails = graphql(`
  query GetAnalyticsCallDetails($input: AnalyticsCallDetailsInput!) {
    analyticsCallDetails(input: $input) {
      __typename
      ... on AnalyticsCallDetails {
        id
        disconnectedBy
      }
      ... on GenericException {
        ...BaseException
      }
      ... on ResourceNotFoundException {
        ...BaseException
      }
      ... on RetryableException {
        ...BaseException
      }
    }
  }
`);
